import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AccountPage } from './account';

import { ComponentsModule } from "../../components/components.module";
import { PipesModule } from "../../pipes/pipes.module";
@NgModule({
  declarations: [
    AccountPage,
  ],
  imports: [
    IonicPageModule.forChild(AccountPage),
    ComponentsModule,
    PipesModule,
  ],
})
export class AccountPageModule { }



// WEBPACK FOOTER //
// ./src/pages/account/account.module.ts